<template>
  <div class="account-card">
    <div class="account-card__column">
      <div class="account-card__header-cell">
        <div class="account-card__agency-account-type">
          <span class="account-card__agency-account-type-title">{{
            $t('account_card.title')
          }}</span>
          <span
            v-if="isShowAgencyAccountType && agentAccountType"
            class="account-card__agency-account-type-text"
            >{{ agentAccountType }}</span
          >
          <div
            v-if="platform === 'telegram' && info.telegram_self_labeling"
            class="auto_labeling_label"
          >
            {{ $t('account_card.auto_labeling') }}
          </div>
        </div>
      </div>
      <div class="account-card__body-cell">
        <a
          v-if="platform === 'mytarget'"
          href="https://target.my.com/clients/list"
          target="_blank"
          class="account-card__account-name"
        >
          {{ fixedName(info.account_name) }}
        </a>
        <span class="account-card__account-name" v-else>
          {{ fixedNameVK(info.account_name) }}
        </span>
        <div v-if="info.description" v-html="info.description" class="account-card__description" />
      </div>
    </div>
    <div class="account-card__column">
      <div class="account-card__header-cell">
        {{ $t('account_card.remainder') }}
      </div>
      <div class="account-card__body-cell center no-wrap">
        {{
          info.balance
            ? platform === 'google' || locale === 'USA'
              ? numberWithSpacesFixed(info.balance, 2)
              : numberWithSpacesCeil(info.balance)
            : 0
        }}
        {{ currency_symbols[info.service_currency] }}
      </div>
    </div>
    <div class="account-card__column">
      <div class="account-card__header-cell">
        {{ $t('account_card.expenses_today') }}
      </div>
      <div class="account-card__body-cell center no-wrap">
        {{
          info.spent
            ? platform === 'google' || locale === 'USA'
              ? numberWithSpacesFixed(info.spent, 2)
              : numberWithSpacesCeil(info.spent)
            : 0
        }}
        {{ currency_symbols[info.service_currency] }}
      </div>
    </div>
    <div class="account-card__column">
      <div class="account-card__header-cell">
        {{ $t('account_card.status') }}
      </div>
      <div class="account-card__body-cell">
        <div :class="`account-card__status account-card__status--${info.status}`">
          {{ info.status }}
        </div>
      </div>
    </div>
    <div class="account-card__column">
      <div class="account-card__header-cell account-card__header-cell-buttons">
        <ButtonElement
          v-if="
            info.campaings &&
            platform === 'telegram' &&
            role !== 'partner' &&
            (info.status === 'active' || info.status === 'archive')
          "
          text="Добавить токен"
          class="account-card__add-token-button"
          ghost
          @click-button="openBindingCreativeDialog(info)"
        />
        <ButtonElement
          v-if="info.status === 'pending' || info.status === 'declined'"
          :text="$t('button_props.verify')"
          view="empty"
          @click-button="checkAccount(info.id)"
        />
        <ButtonElement
          v-if="info.status === 'active' || info.status === 'archive'"
          :text="$t('button_props.add')"
          @click-button="fillAccount(info)"
          :disabled="isButtonDisabled"
        />
      </div>
      <div class="account-card__body-cell">
        <div class="account-card__info-wrapper">
          <div class="account-card__info">
            <span class="account-card__companies-count"
              >{{ info.campaings }}
              {{
                declOfNum(info.campaings, [
                  $t('account_card.campaigns.0'),
                  $t('account_card.campaigns.1'),
                  $t('account_card.campaigns.2'),
                ])
              }}</span
            >
            <div
              v-if="info.commission_replenishment && platform === 'telegram'"
              class="account-card__commision-replenishment-wrapper"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 2H15C20 2 22 4 22 9V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2Z"
                  fill="#9B9FA8"
                />
                <path
                  d="M8.57007 15.2704L15.11 8.73047"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.98001 10.3701C9.65932 10.3701 10.21 9.81948 10.21 9.14017C10.21 8.46086 9.65932 7.91016 8.98001 7.91016C8.3007 7.91016 7.75 8.46086 7.75 9.14017C7.75 9.81948 8.3007 10.3701 8.98001 10.3701Z"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.52 16.0909C16.1993 16.0909 16.75 15.5402 16.75 14.8608C16.75 14.1815 16.1993 13.6309 15.52 13.6309C14.8407 13.6309 14.29 14.1815 14.29 14.8608C14.29 15.5402 14.8407 16.0909 15.52 16.0909Z"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>{{ info.commission_replenishment }} %</span>
            </div>
            <el-dropdown
              v-if="isShowEditDropdown"
              class="account-card__companies-change"
              trigger="click"
              @command="handleCommandForAccount"
            >
              <span class="el-dropdown-link account-card__companies-change__btn">
                <svg
                  width="3"
                  height="17"
                  viewBox="0 0 3 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3 1.5C3 2.32843 2.32843 3 1.5 3C0.671573 3 0 2.32843 0 1.5C0 0.671573 0.671573 0 1.5 0C2.32843 0 3 0.671573 3 1.5ZM3 8.5C3 9.32843 2.32843 10 1.5 10C0.671573 10 0 9.32843 0 8.5C0 7.67157 0.671573 7 1.5 7C2.32843 7 3 7.67157 3 8.5ZM1.5 17C2.32843 17 3 16.3284 3 15.5C3 14.6716 2.32843 14 1.5 14C0.671573 14 0 14.6716 0 15.5C0 16.3284 0.671573 17 1.5 17Z"
                    fill="#9BA2AB"
                  />
                </svg>
              </span>
              <el-dropdown-menu
                class="account-card__companies-change__list"
                :class="{ 'locale-usa': locale === 'USA' }"
                slot="dropdown"
              >
                <el-dropdown-item
                  v-if="platform === 'mytarget'"
                  class="account-card__companies-change__list-item"
                >
                  <a href="https://target.my.com/clients/list" target="_blank">{{
                    $t('account_card.go_to_my_target')
                  }}</a>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    platform !== 'yandex' &&
                    platform !== 'promopages' &&
                    platform !== 'facebook' &&
                    platform !== 'telegram' &&
                    platform !== 'yandexbusiness' &&
                    platform !== 'vkadblogger' &&
                    (this.locale === 'USA' ||
                      (platform !== 'google' &&
                        (role === 'partner'
                          ? activeAccount.services[platform]
                          : activeAccount.visible_services[platform])))
                  "
                  class="account-card__companies-change__list-item"
                  :command="{ name: 'transfer' }"
                >
                  <span>{{ $t('account_card.money_back') }} {{ platform }}</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    platform !== 'promopages' &&
                    (role === 'manager' || role === 'finance' || role === 'admin')
                  "
                  class="account-card__companies-change__list-item"
                  :command="{
                    name: 'info',
                    data: {
                      accountName: info.account_name,
                      accountId: info.id,
                      businessAccountId: info.business_account_id,
                      platform,
                    },
                  }"
                >
                  {{ $t('account_card.check_balance') }}
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="(role === 'manager' || role === 'admin') && platform === 'vkontakte'"
                  class="account-card__companies-change__list-item"
                  :command="{
                    name: 'changeProfileLink',
                    data: {
                      accountName: info.account_name,
                      accountId: info.id,
                      businessAccountId: info.business_account_id,
                    },
                  }"
                >
                  {{ $t('account_card.change_profile_link') }}
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="role === 'manager' || role === 'finance' || role === 'admin'"
                  class="account-card__companies-change__list-item"
                  :command="{
                    name: 'delete',
                    account: info.id,
                  }"
                >
                  {{ $t('delete') }}
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    (role === 'manager' || role === 'finance' || role === 'admin') &&
                    (info.status === 'active' || info.status === 'created') &&
                    platform === 'telegram'
                  "
                  class="account-card__companies-change__list-item"
                  :command="{
                    name: 'setCommission',
                    data: {
                      accountName: info.account_name,
                      accountId: info.id,
                      businessAccountId: info.business_account_id,
                      platform,
                      commission: info.commission_replenishment,
                    },
                  }"
                >
                  {{ $t('account_card.set_commission') }}
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    (role === 'manager' || role === 'finance' || role === 'admin') &&
                    platform === 'telegram'
                  "
                  class="account-card__companies-change__list-item"
                  :command="{
                    name: 'toggleAutoLabeling',
                    data: {
                      accountId: info.id,
                      currentValue: info.telegram_self_labeling,
                    },
                  }"
                >
                  {{
                    info.telegram_self_labeling
                      ? $t('account_card.auto_labeling_off')
                      : $t('account_card.auto_labeling_on')
                  }}
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="isSuperAdmin && (info.status === 'archive' || info.status === 'active')"
                  class="account-card__companies-change__list-item"
                  :command="{ name: 'activate', account: info.id }"
                >
                  {{ $t('account_card.activate_account') }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <div v-if="info.commission_replenishment" class="account-card__companies-commission">
          <img src="@/assets/icons/icon-round-dollar.svg" alt=""> <span>{{ info.commission_replenishment }} %</span>
    </div> -->
          <el-dialog
            class="account-card__popup"
            :visible.sync="dialogVisible"
            width="43.4rem"
            top="0"
            append-to-body
          >
            <div
              class="account-card__popup-close"
              :class="{ 'locale-usa': locale === 'USA' }"
              @click="dialogVisible = false"
            >
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.5572 8.27283C26.2163 7.61382 27.2847 7.61382 27.9437 8.27283C28.6027 8.93184 28.6027 10.0003 27.9437 10.6593L10.4428 28.1602C9.78383 28.8192 8.71536 28.8192 8.05635 28.1602C7.39734 27.5012 7.39735 26.4327 8.05635 25.7737L25.5572 8.27283Z"
                  fill="#BFC2C6"
                />
                <path
                  d="M27.9437 25.7736C28.6027 26.4326 28.6027 27.501 27.9437 28.16C27.2847 28.819 26.2162 28.819 25.5572 28.16L8.05634 10.6591C7.39733 10.0001 7.39733 8.93167 8.05634 8.27266C8.71535 7.61365 9.78382 7.61365 10.4428 8.27266L27.9437 25.7736Z"
                  fill="#BFC2C6"
                />
              </svg>
            </div>

            <div class="account-card__popup-inner" v-loading="loading">
              <div class="account-card__popup-title">
                {{ $t('account_card.refund') }}
              </div>
              <div class="account-card__popup-text">
                {{ $t('account_card.transfer_amount') }}
              </div>

              <div
                class="form-input account-card__popup-input"
                :class="[
                  { 'form-input--full': returnAmount },
                  {
                    'form-input--disabled': returnAmountFull,
                  },
                ]"
              >
                <input v-model="returnAmount" type="text" :disabled="returnAmountFull" />
                <span class="form-input__label">
                  {{ $t('account_card.total') }}
                </span>
              </div>
              <SwitchButton
                :label="$t('account_card.total_amount')"
                @change="
                  (val) => {
                    returnAmountFull = val;
                  }
                "
              />

              <div class="account-card__popup-btns" :class="{ 'locale-usa': locale === 'USA' }">
                <button
                  class="account-card__popup-btn"
                  :disabled="isDisabled"
                  @click="transferFromAccount"
                >
                  {{ $t('account_card.transfer') }}
                </button>
                <button
                  class="account-card__popup-btn account-card__popup-btn--cancel"
                  @click="dialogVisible = false"
                >
                  {{ $t('account_card.cancel') }}
                </button>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchButton from '@/components/elements/SwitchElement';
import ButtonElement from '@/components/elements/ButtonElement';
import numberWithSpacesCeil from '@/mixin/numberWithSpaces';
import numberWithSpacesFixed from '@/mixin/numberWithSpaces';
// import { getRepresentativeAccess } from "@/utils/helpers";

export default {
  name: 'AccountCard',
  props: {
    platform: {
      type: String,
      default: '',
    },
    info: {
      type: Object,
      default: null,
    },
  },
  components: {
    ButtonElement,
    // SwitchButton
  },
  mixins: [numberWithSpacesCeil, numberWithSpacesFixed],
  data() {
    return {
      locale: process.env.VUE_APP_LOCALE,
      isData: false,
      isCompanies: false,
      dialogVisible: false,
      campaignList: [],
      isDisabled: false,
      loading: false,
      returnAmount: null,
      returnAmountFull: false,
      currency_symbols: {
        RUB: '₽',
        USD: '$',
        EUR: '€',
        PLN: 'zł',
      },
    };
  },
  computed: {
    activeAccount() {
      return this.$store.state.Auth.activeAccount;
    },
    role() {
      return this.$store.state.Auth.role;
    },
    isSuperAdmin() {
      return this.role === 'admin';
    },
    checkLimit() {
      return (
        this.info &&
        Object.prototype.hasOwnProperty.call(this.info, 'limit_type') &&
        this.info.limit_type === null
      );
    },
    agentAccountType() {
      if (this.platform === 'mytarget') {
        return this.info.agency_account_type === 'default'
          ? 'Gray'
          : this.info.agency_account_type === 'profitads'
          ? 'Profitads'
          : this.info.agency_account_type === 'white'
          ? 'AM'
          : '';
      }
      if (this.platform === 'yandex') {
        return this.info.agency_account_type === 'default'
          ? 'AM'
          : this.info.agency_account_type === 'profitads'
          ? 'Profitads'
          : '';
      }
      if (this.platform === 'vkontakte') {
        return this.info.agency_account_type === 'default'
          ? 'AM'
          : this.info.agency_account_type === 'profitads'
          ? 'Profitads'
          : '';
      }
      if (this.platform === 'promopages') {
        return this.info.agency_account_type === 'default'
          ? 'AM'
          : this.info.agency_account_type === 'profitads'
          ? 'Profitads'
          : '';
      }
      if (this.platform === 'vkads') {
        return this.info.agency_account_type === 'default'
          ? 'AM'
          : this.info.agency_account_type === 'profitads'
          ? 'Profitads'
          : '';
      }
      if (this.platform === 'google') {
        return this.info.agency_account_type === 'default'
          ? 'DE Google'
          : this.info.agency_account_type === 'easystart'
          ? 'DE GoogleES'
          : '';
      }
      if (this.platform === 'tiktok') {
        if (this.locale === 'RU') {
          return this.info.agency_account_type === 'default'
            ? 'AM'
            : this.info.agency_account_type === 'profitads'
            ? 'Profitads'
            : '';
        }
        if (this.locale === 'USA') {
          return this.info.agency_account_type === 'default'
            ? 'DE TikTok'
            : this.info.agency_account_type === 'am'
            ? 'AM TikTok'
            : '';
        }
      }
      if (this.platform === 'facebook') {
        return this.info.agency_account_type === 'default'
          ? 'DE MetaUSD'
          : this.info.agency_account_type === 'digital_pln'
          ? 'DE MetaPLN'
          : '';
      }
      return '';
    },
    isShowAgencyAccountType() {
      switch (this.locale) {
        case 'USA':
          if (this.platform === 'yandex' || this.platform === 'vkads') {
            return false;
          }
          break;
        case 'RU':
          if (
            this.platform === 'google' ||
            this.platform === 'meta' ||
            this.platform === 'tiktok' ||
            this.platform === 'telegram'
          ) {
            return false;
          }
          break;
      }
      return true;
    },
    isButtonDisabled() {
      if (this.role !== 'partner') {
        return !this.activeAccount.visible_services[this.platform];
      } else {
        return !this.isRepresentativeAllowed;
      }
    },
    user() {
      return this.$store.state.Auth.user;
    },
    businessAccountInfo() {
      return this.$store.state.Representatives.representativeBAInfo;
    },
    isRepresentativeAllowed() {
      const permissionString = `advert.${this.platform}.finance`;
      const isAllowed = this.businessAccountInfo.permissions.includes(permissionString);
      return isAllowed;
    },
    isShowEditDropdown() {
      let condition;
      if (this.role === 'partner') {
        condition =
          this.activeAccount &&
          this.activeAccount.services.length > 0 &&
          this.activeAccount.services.includes(this.platform);
      } else {
        condition =
          this.activeAccount &&
          this.activeAccount.visible_services &&
          (this.activeAccount.visible_services[this.platform] ||
            this.role === 'manager' ||
            this.role === 'finance' ||
            this.role === 'admin');
      }
      return condition;
    },
    isShowCampaignDropdown() {
      const condition =
        this.role === 'partner'
          ? this.activeAccount.services[this.platform]
          : this.activeAccount.visible_services[this.platform];
      return condition;
    },
    localCurrency() {
      return this.locale === 'USA' ? 'USD' : 'RUB';
    },
  },
  methods: {
    getPic(locale) {
      if (locale === 'RU') {
        return require('@/assets/icons/icon-arrow-blue.svg');
      } else {
        return require('@/assets/icons/icon-arrow-red.svg');
      }
    },

    checkAccount(id) {
      const data = {
        service: this.platform,
        business_account_id: this.activeAccount.id,
        account_id: id,
      };
      this.$store.dispatch('Ad/checkAccount', data).then((data) => {
        if (data.data.data.error) {
          this.$alert(data.data.data.error, {
            confirmButtonText: 'OK',
            customClass: `${this.locale === 'USA' ? 'locale-usa' : 'locale-ru'}`,
          });
        }
        this.$emit('check-status');
      });
    },
    fillAccount(account) {
      this.$store.commit('Balance/setData', {
        label: 'filledAccount',
        data: account,
      });
      this.$store.commit('Dialog/setData', {
        label: 'activeDialog',
        data: 'Deposit',
      });
      this.$store.commit('Dialog/setData', {
        label: 'dialogVisible',
        data: true,
      });
    },
    fixedName(name) {
      if (name.length > 20) {
        return name.substring(0, 18) + '...';
      } else {
        return name;
      }
    },
    fixedNameVK(name) {
      if (name.startsWith('http')) {
        return name.split('/')[3] || '';
      } else {
        return name;
      }
    },
    openEditingLimitDialog(data) {
      this.$store.commit('Company/setData', {
        label: 'companyData',
        data,
      });
      this.$store.commit('Dialog/setData', {
        label: 'activeDialog',
        data: 'EditingLimit',
      });
      this.$store.commit('Dialog/setData', {
        label: 'dialogVisible',
        data: true,
      });
    },
    openFundsInfoDialog(data) {
      this.$store.commit('Company/setData', {
        label: 'companyData',
        data,
      });
      this.$store.commit('Dialog/setData', {
        label: 'activeDialog',
        data: 'FundsInfo',
      });
      this.$store.commit('Dialog/setData', {
        label: 'dialogVisible',
        data: true,
      });
    },
    openSetCommissionDialog(data) {
      this.$store.commit('Company/setData', {
        label: 'companyData',
        data,
      });
      this.$store.commit('Dialog/setData', {
        label: 'activeDialog',
        data: 'SetCommission',
      });
      this.$store.commit('Dialog/setData', {
        label: 'dialogVisible',
        data: true,
      });
    },
    openBusinessAccountClientsDialog(data) {
      this.$store.commit('Ad/setData', { label: 'currentNewUser', data });
      this.$store.commit('Dialog/setData', {
        label: 'activeDialog',
        data: 'BusinessAccountClients',
      });
      this.$store.commit('Dialog/setData', {
        label: 'dialogVisible',
        data: true,
      });
    },
    openTransferFromAccount() {
      this.dialogVisible = true;
    },
    transferFromAccount() {
      if (!this.returnAmountFull && !this.returnAmount) {
        this.$notify({
          message: this.$t('account_card.enter_amount'),
          type: 'error',
        });
        return false;
      }
      this.isDisabled = true;
      this.loading = true;
      const data = {
        service: this.info.service,
        account_id: this.info.id,
      };
      if (!this.returnAmountFull && this.returnAmount) {
        data.amount = this.returnAmount;
      }
      this.$store
        .dispatch('Ad/transferFromAccountToBusinessAccount', { data })
        .then(() => {
          this.isDisabled = false;
          this.loading = false;
          this.dialogVisible = false;
          this.$notify({
            message: this.$t('account_card.money_returned'),
            type: 'success',
          });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch(() => {
          this.dialogVisible = false;
          this.isDisabled = false;
          this.loading = false;
          this.$notify({
            message: this.$t('account_card.try_later'),
            type: 'error',
          });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        });
    },
    handleCommand(command) {
      if (command.name === 'open') {
        this.openEditingLimitDialog(command.data);
      }
    },
    handleCommandForAccount(command) {
      if (command.name === 'delete') {
        const data = {
          data: { account_id: command.account },
          token: localStorage.getItem('token'),
        };
        this.$store
          .dispatch('Ad/deleteAccount', data)
          .then(() => {
            this.$notify({
              message: this.$t('account_card.message_del'),
              type: 'success',
            });
            this.$emit('check-status');
          })
          .catch(() => {
            this.$notify({
              message: this.$t('account_card.message_err'),
              type: 'error',
            });
          });
      } else if (command.name === 'transfer') {
        this.openTransferFromAccount();
      } else if (command.name === 'info') {
        this.openFundsInfoDialog(command.data);
      } else if (command.name === 'changeProfileLink') {
        this.openBusinessAccountClientsDialog(command.data);
      } else if (command.name === 'setCommission') {
        this.openSetCommissionDialog(command.data);
      } else if (command.name === 'toggleAutoLabeling') {
        this.toggleAutoLabeling(command.data);
      } else if (command.name === 'activate') {
        this.activateAdvertAccount(command.account);
      }
    },
    activateAdvertAccount(accountId) {
      const token = localStorage.getItem('token');
      const data = { account_id: accountId };

      this.$store
        .dispatch('Ad/activateAdvertAccount', { data, token })
        .then((resp) => {
          const message =
            resp?.data?.message ||
            resp?.data?.data?.message ||
            this.$t('account_card.activate_success');
          this.$notify({
            message,
            type: 'success',
          });
          this.$emit('check-status');
        })
        .catch((error) => {
          const message = error?.response?.data?.message || this.$t('account_card.activate_error');
          this.$notify({
            message,
            type: 'error',
          });
        });
    },
    declOfNum(number, titles) {
      const cases = [2, 0, 1, 1, 1, 2];
      return titles[
        number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
    openBindingCreativeDialog() {
      this.$store.dispatch('Balance/setFilledAccount', this.info);
      this.$router.push({
        path: '/creatives',
        query: { platform: 'telegram' },
      });

      // this.$store.commit('Dialog/setData', { label: 'activeDialog', data: 'BindCreative' })
      // this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: true })
    },
    toggleAutoLabeling(data) {
      const requestData = {
        value: !data.currentValue,
        account_id: data.accountId,
      };
      const token = localStorage.getItem('token');
      this.$store
        .dispatch('Ad/toggleTelegramSelfLabeling', {
          data: requestData,
          token,
        })
        .then(() => {
          this.$notify({
            message: requestData.value
              ? this.$t('account_card.auto_labeling_enabled')
              : this.$t('account_card.auto_labeling_disabled'),
            type: 'success',
          });
          this.$emit('check-status');
        })
        .catch(() => {
          this.$notify({
            message: this.$t('account_card.auto_labeling_error'),
            type: 'error',
          });
        });
    },
    // getRepresentativeAccess(permissionToCheck){
    //   return getRepresentativeAccess(permissionToCheck, this.businessAccountInfo, this.role)
    // },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.account-card {
  display: grid;
  grid-template-columns: 24rem 9rem 16rem 9rem 1fr;
  grid-template-areas: 'account-name balance expenses status actions';
  background: #ffffff;
  border-radius: 6px;
  overflow: hidden;

  @include below(1024px) {
    grid-template-areas:
      'account-name account-name account-name'
      'balance expenses expenses'
      'status actions actions';
    grid-template-columns: 1fr 1fr 1fr;
  }

  &__companies-commission-wrapper {
    display: flex;
  }

  &.has-auto-labeling {
    padding-top: 2.4rem;
  }

  .auto_labeling_label {
    display: inline-flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    padding: 0 8px;
    height: 2.5rem;
    line-height: 2.6rem;
    border-radius: 4px;
    white-space: nowrap;

    color: #9b9fa8;
    background: $gray6;
  }

  @include below(768px) {
    grid-template-areas:
      'account-name account-name'
      'balance expenses'
      'status actions';
    grid-template-columns: 1fr 1fr;
  }

  @include below(480px) {
    grid-template-areas:
      'account-name account-name'
      'balance expenses'
      'status status'
      'actions actions';
    grid-template-columns: 1fr;
    border: 1px solid $border;
    border-radius: 1.4rem;
  }

  @include below(480px) {
    .account-card {
      &__column:nth-child(3) {
        display: none;
      }

      &__companies-count {
        display: none;
      }
    }
  }

  &__agency-account-type {
    display: flex;
    gap: 10px;
    align-items: center;

    @include below(480px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 3px;
    }

    &-text {
      display: flex;
      background: #ffffff;
      color: #395fe4;
      padding: 2px 8px;
      border-radius: 4px;
      font-weight: 400;
      font-size: 16px;

      @include below(480px) {
        background: #f6f7f9;
        font-size: 10px;
        padding: 1px 4px;
      }
    }
  }

  &__account-name {
    display: inline;
    background: #f6f7f9;
    word-break: break-all;
    width: max-content;
    color: #9b9fa8;
    font-weight: 400;
    font-size: 16px;
    padding: 2px 8px;
    border-radius: 4px;
  }

  &__description {
    word-break: break-all;
    font-weight: 700;
    font-size: 18px;
    color: #333333;
  }

  &__info-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;

    @include below(480px) {
      justify-content: center;
      border: 1px solid $border;
      border-radius: 0.8rem;
    }
  }

  &__info {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;

    &-name {
      width: 25rem;
      > .account-card__info-title {
        display: grid;
        grid-template-columns: minmax(0, max-content) minmax(0, max-content);
        grid-column-gap: 1.4rem;
        align-items: center;
        .agency_account_type {
          font-family: 'Inter';
          font-weight: 400;
          font-size: 12px;
          line-height: 14px;
          color: #333;
          padding: 7px 8px;
          background: #f5f7fa;
          border-radius: 4px;
        }
      }
    }

    &-title {
      font-size: 1.6rem;
      line-height: 1.9rem;
      color: #aaa;
      margin-bottom: 0.5rem;
    }

    &-description {
      font-size: 2rem;
      line-height: 2.4rem;
    }

    &-value {
      font-size: 1.4rem;
      line-height: 1.6rem;
      color: #9ba2ab;
      word-wrap: break-word;

      &--bold {
        font-weight: 700;
        font-size: 1.6rem;
        line-height: 2.4rem;
        color: #000;
      }
    }

    &-add {
      width: 12.5rem;

      .button {
        height: 100%;
      }
    }

    .button {
      height: 35px;
    }
  }

  &__commision-replenishment-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 400;
    font-size: 12px;
    color: #9ba2ab;
  }

  &__column {
    display: flex;
    flex-direction: column;

    @include below(480px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
    }

    &:nth-child(1) {
      grid-area: account-name;
    }
    &:nth-child(2) {
      grid-area: balance;
    }
    &:nth-child(3) {
      grid-area: expenses;
    }
    &:nth-child(4) {
      grid-area: status;
    }
    &:nth-child(5) {
      grid-area: actions;
    }

    &:last-child {
      .account-card__header-cell,
      .account-card__body-cell {
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  &__header-cell-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;

    .button {
      height: 35px;
      width: 125px;
    }

    @include below(480px) {
      justify-content: flex-start;
    }
  }

  &__body-cell {
    &.center {
      display: flex;
      align-items: center;
      justify-content: center;

      @media (max-width: 1024px) {
        align-items: flex-start;
        justify-content: flex-start;
      }
    }

    &.no-wrap {
      white-space: nowrap;
    }
  }

  &__header-cell,
  &__body-cell {
    padding: 10px;

    &:first-child {
      padding-left: 1.4rem;
    }

    &:last-child {
      padding-right: 1.4rem;
    }
  }

  &__header-cell {
    background: #f6f7f9;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    color: #9ba2ab;
    height: 52px;
    display: flex;
    align-items: center;
    text-align: center;

    @include below(480px) {
      background: none;
    }
  }

  &__add-token-button {
    font-weight: 700;
    font-size: 13px;
  }

  &__status {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 16px;
    border-radius: 8px;
    padding: 2px 8px;

    &--active {
      color: #308e58;
      background: #e5fcef;
    }
    &--pending {
      color: #395fe4;
      background: #d6e0f2;
    }
    &--declined,
    &--archive {
      color: #9b9fa8;
      background: #f6f7f9;
    }
    &--created {
      color: #ff7f50;
      background: #fff4ec;
    }
    &--blocked {
      color: #eb5757;
      background: #f6f7f9;
    }
  }

  &__companies-count {
    font-size: 14px;
    line-height: 1.7rem;
    color: $gray2;
    display: flex;
    align-items: center;
  }

  &__companies-change__btn {
    display: flex;
    cursor: pointer;
  }

  @include below(480px) {
    &__companies-change__btn {
      padding: 1.35rem;
    }

    .auto_labeling_label {
      font-size: 12px;
    }

    &__column {
      &:last-child {
        padding-block: 1.2rem;
      }

      &:first-child {
        padding-top: 1.2rem;
      }
    }

    &__column:nth-child(5) {
      display: grid;
      grid-template-columns: 1fr auto;
    }

    &__header-cell {
      font-size: 14px;
      padding: 4px 6px;
      height: auto;
      min-height: 32px;
    }

    &__body-cell {
      padding: 4px 6px;
      font-size: 14px;
    }

    &__account-name {
      font-size: 11px;
      padding: 2px 4px;
    }

    &__description {
      font-size: 14px;
      line-height: 1.2;
      margin-top: 2px;
    }

    &__status {
      font-size: 12px;
    }

    &__companies-change__btn {
      svg {
        width: 12px;
        height: 12px;
      }
    }

    &__header-cell-buttons {
      gap: 1rem;

      .button {
        height: 38px;
        width: 100%;
        min-width: 60px;
        font-size: 14px;
        padding: 0 8px;
        max-width: 50%;
        font-weight: 500;
      }
    }

    &__commision-replenishment-wrapper {
      font-size: 9px;
    }

    &__agency-account-type-text {
      font-size: 10px;
      padding: 1px 4px;
    }

    &__column:last-child &__header-cell {
      justify-content: flex-start;
    }
  }
}
</style>
